var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 4.8C1.6001 4.37565 1.76867 3.96868 2.06873 3.66863C2.36878 3.36857 2.77575 3.2 3.2001 3.2H7.2001L8.8001 4.8H12.8001C13.2244 4.8 13.6314 4.96857 13.9315 5.26863C14.2315 5.56868 14.4001 5.97565 14.4001 6.4V11.2C14.4001 11.6243 14.2315 12.0313 13.9315 12.3314C13.6314 12.6314 13.2244 12.8 12.8001 12.8H3.2001C2.77575 12.8 2.36878 12.6314 2.06873 12.3314C1.76867 12.0313 1.6001 11.6243 1.6001 11.2V4.8Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.b1d55b1e57d529ecd7661ec3333c17fe.svg";
export { ForwardRef as ReactComponent };